import { useQuery } from '@tanstack/react-query';
import { getQuoteById } from '../service';

function useViewOnlineQuote(quoteId: number) {
    return useQuery({
        queryKey: ['quote-approval-url', quoteId],
        queryFn: async () => {
            const quote = await getQuoteById(quoteId);

            if (quote.approvalUrl === null) {
                throw new Error('This quote is no longer available to view online.');
            }

            window.location.replace(quote.approvalUrl);
            return quote;
        },
        retry: false,
    });
}

export { useViewOnlineQuote };
